import type { DatetimeString } from '#/types/TypedDateString';

export const MS_PER_DAY = 1000 * 60 * 60 * 24;

export function daysDifference(one: DatetimeString, two: DatetimeString) {
  const dateOne = new Date(one);
  const dateTwo = new Date(two);

  return Math.floor((dateOne.getTime() - dateTwo.getTime()) / MS_PER_DAY);
}
